
import './Training.css';

import React from 'react';

export default function OfficialTrainingCard({ duration, title, institution, units }) {
  return (
    <div className="official-training-card">

      {/* Duration Badge */}
      <div className="training-duration-badge">{duration}</div>

      {/* Main Info */}
      <div className="training-main">
        <div className="training-text">
          <h2 className="training-title">{title}</h2>
          <p className="training-institution">{institution}</p>
          {units && <p className="training-units">{units}</p>}
        </div>
      </div>

    </div>
  );
}

